import React from 'react';

import ContentCard from 'pages/Landings/components/ContentCard';

import VulnersIcon from './assets/vulners.svg';
import useStyles from './styles';

interface Props {
    className?: string;
}

const Requisites: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    return (
        <ContentCard
            picture={<VulnersIcon />}
            title={'Vulners, Inc.'}
            subtitle={'Delaware, Wilmington 19801 1000 N West Street, Suite 1200'}
            className={className}
        >
            <div className={classes.main}>
                <div className={classes.grid}>
                    <span className={cx(classes.text, classes.name)}>{'File number'}</span>
                    <span className={cx(classes.text, classes.value)}>{'7505095'}</span>
                    <span className={cx(classes.text, classes.name)}>{'EIN'}</span>
                    <span className={cx(classes.text, classes.value)}>{'84-2354848'}</span>
                </div>
                <div className={classes.grid}>
                    <span className={cx(classes.text, classes.name)}>{'Phone'}</span>
                    <span className={cx(classes.text, classes.value)}>{'+13028303742'}</span>
                    <span className={cx(classes.text, classes.name)}>{'Email'}</span>
                    <span className={cx(classes.text, classes.value)}>{'support@vulners.com'}</span>
                </div>
            </div>
        </ContentCard>
    );
};

export default Requisites;
